angular.module('mtic.components.dashboards.teacher_general', [
  'mtic',
  'angular.filter',
  'mtic.components.modules',
  'mtic.components.custom_calendar',
  'mtic.components.user_box',
  'ui.tree'
])

angular.module('mtic.components.dashboards.teacher_general')
.directive('dashboardTeacher', function ($log, $http, EventManager, PanelFactory, TeacherDataService, language, $rootScope, PlatformService) {
  return {
    templateUrl: 'template.html',
    scope: {},
    link: function (scope) {
      var eventManager = new EventManager('teacherDashboard', scope);
      eventManager.broadcast('app:secondary:opened', 'Teacher');

      scope.$watch('showClasses', function(){
        if(scope.$parent.$parent.pageShown === 'teacher'){
          if(scope.showClasses){
            $rootScope.pageView = 'teacher-classes-view';
          }
          else{
            $rootScope.pageView = 'teacher-students-view';
          }
          $rootScope.sidebarExpanded = PlatformService.isPhonePortrait() && window.location.href.indexOf('open_item_link') === -1  ? false : true;
        }
      });

      scope.showClasses = true;

      eventManager.broadcast('language:init', language.getCurrentSelectedLanguage());

      eventManager.listen("navbar:my-classes:click", function(){
        scope.showClasses = true;
      });

      eventManager.listen('teacher:view:class', function(){
        scope.showClasses = false;
      });

    }

  }
})
